import { createSelector } from 'reselect';

export const creditsSelector = (state) => state.get('credits');

export const creditsByIdSelector = createSelector(creditsSelector, (credits) =>
  credits.get('byId')
);

export const creditsAllIdsSelector = createSelector(
  creditsSelector,
  (credits) => credits.get('allIds')
);

export const creditsByProjectIdSelector = createSelector(
  creditsSelector,
  (credits) => credits.get('byProjectId')
);

export const creditsByInstanceIdSelector = createSelector(
  creditsSelector,
  (credits) => credits.get('byInstanceId')
);
